// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children }) => {
  const user = Cookies.get("user_id"); // replace 'user_id' with your cookie key if different

  if (!user) {
    return <Navigate to="/admin/AdminLogin" replace />;
  }

  return children;
};

export default ProtectedRoute;
